import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: 32,
  },
  text: {
    fontSize: 12,
    textDecorationLine: 'underline',
    marginHorizontal: 4,
  },
  buttonIcon: {
    textAlign: 'center',
    marginHorizontal: 4,
    padding: 5,
    borderRadius: 20,
    textDecorationLine: 'none',
    width: 24,
    height: 24,
  },
});
